module.exports = {
  CHANGE_ALERT_CHANNEL: 'CHANGE_ALERT_CHANNEL',
  RECEIVE_DEVICE_ALERTS: 'RECEIVE_DEVICE_ALERTS',
  RECEIVE_DEVICE_MONITOR_CONFIG: 'RECEIVE_DEVICE_MONITOR_CONFIG',
  RECEIVE_DEVICE_ISSUE_COUNTS: 'RECEIVE_DEVICE_ISSUE_COUNTS',
  RECEIVE_LATEST_DEVICE_ALERTS: 'RECEIVE_LATEST_DEVICE_ALERTS',
  alertChannels: {
    email: 'email'
  }
};
